import { FC, memo, useCallback } from 'react'

import { Text } from '@cash-me/react-components'

import { Carousel } from 'components/carousel'
import { Grid, Col } from 'components/grid'
import { pushDataLayer } from 'utils/push-data-layer'

import { cards } from './data'
import * as S from './styles'

const Modalities: FC = memo(() => {
  const handleDataLayer = useCallback((index: number) => {
    pushDataLayer({
      category: 'Slider',
      action: 'Home Equity',
      label: `Outras modalidades - Slide ${cards[index].title}`
    })
  }, [])

  return (
    <S.Section>
      <Grid col={{ phone: 1, tablet: 12 }} gap={{ phone: 'xxs' }}>
        <Col col={{ tablet: 5, desktop: 5 }} start={{ desktop: 2 }}>
          <S.Infos>
            <Text
              className="subtitle"
              size="caption"
              weight="medium"
              uppercase
              color="var(--colors-neutral-text-contrast-default)"
            >
              Outras modalidades de empréstimo
            </Text>

            <Text as="h2" size="heading3" weight="medium" color="var(--colors-neutral-text-contrast-default)">
              <Text as="span" size="heading3" weight="medium" color="var(--colors-cyan-text-contrast)">
                Seu crédito{' '}
              </Text>
              com as melhores taxas
            </Text>

            <Text as="h4" size="heading4" weight="medium" color="var(--colors-neutral-text-contrast-default)">
              Conheça as outras modalidades de Crédito comparadas ao Home Equity
            </Text>

            <Text className="description" color="var(--colors-neutral-text-contrast-default)">
              Já vimos que o Home Equity tem como fundamento a alienação fiduciária. Assim, a instituição credora sabe
              que o imóvel existe e que o tomador do empréstimo teve boa intenção ao colocá-lo como garantia. Por isso,
              os juros oferecidos são baixos e a liberação do crédito é muito prática e rápida. Para comparação com as
              condições do Home Equity, vamos ver como funcionam alguns dos demais tipos de crédito populares no Brasil.
            </Text>
          </S.Infos>
        </Col>

        <Col col={{ tablet: 6, desktop: 6 }} start={{ tablet: 7, desktop: 7 }}>
          <S.CarouselWrapper>
            <Carousel onChangeIndex={handleDataLayer} navigation={true}>
              {cards.map(({ id, title, icon: IconComponent, content }) => (
                <S.Card key={id}>
                  <S.IconWrapper>
                    <IconComponent color="var(--colors-cyan-icon-default)" />
                  </S.IconWrapper>
                  <Text as="h3" size="heading4" weight="medium">
                    {title}
                  </Text>
                  <S.CardContent>{content()}</S.CardContent>
                </S.Card>
              ))}
            </Carousel>
          </S.CarouselWrapper>
        </Col>
      </Grid>
    </S.Section>
  )
})

Modalities.displayName = 'Modalities'

export default Modalities
